import { startGame } from 'outpost';
import { SnuGame } from './snu-game.ts';

function main() {
    startGame(new SnuGame());
}

main();